import { z } from "zod";
import React from "react";
import styled from "styled-components";
import { ArticleCoveredCard } from "../../../molecules/ArticleCoveredCard";
import { Blade } from "../../../components/Blade";
import { LegacyBladeHeader, BladeHeaderHeading, BladeHeaderSupertitle, BladeHeaderTitle, BladeHeaderBody, BladeHeaderDecoration, } from "../../../components/BladeHeader";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { ContentItemBladeSchema } from "../../../schemas/blades/ContentItem";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
import { RichText } from "../../../components/RichText";
import { BladeContent } from "../../../components/BladeContent";
import { arcaneSkin } from "../skins/arcane";
export const AssetHighlightContractSchema = ContentItemBladeSchema.extend({
    type: z.literal("assetHighlight"),
});
const _AssetHighlight = (props) => {
    const { header, content, ...assetHighlightProps } = props;
    const headerContent = hasVisibleContent(header);
    return (React.createElement(Blade, { "data-testid": "assetHighlight", ...assetHighlightProps },
        headerContent && (React.createElement(LegacyBladeHeader, null,
            React.createElement(BladeHeaderHeading, null,
                header?.supertitle && React.createElement(BladeHeaderSupertitle, null, header?.supertitle),
                header?.title && (React.createElement(React.Fragment, null,
                    React.createElement(BladeHeaderTitle, null,
                        React.createElement("h2", null, header.title)),
                    React.createElement(BladeHeaderDecoration, null)))),
            header?.description ? (React.createElement(BladeHeaderBody, null,
                React.createElement(RichText, { ...header.description }))) : null)),
        content && (React.createElement(BladeContent, { width: "xlarge", "data-testid": "asset-container" },
            React.createElement(AnalyticsProvider, { uiLocation: `asset` },
                React.createElement(ArticleCoveredCard, { content: content, "data-testid": "article-covered-card" }))))));
};
export const AssetHighlight = styled(_AssetHighlight) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.Arcane]: arcaneSkin,
})}
`;
//# sourceMappingURL=AssetHighlight.js.map